var MSQR = require('../lib/msqr').MSQR

L.ImageOverlay.CrossOrigin = L.ImageOverlay.extend({
    _updateOpacity: function () {
        this._image.crossOrigin = 'anonymous';
        L.DomUtil.setOpacity(this._image, this.options.opacity);
    },
    remove: function () {
        if (this._map) {
            this._map.removeLayer(this);
        }
    },

    onAdd: function () {
        L.ImageOverlay.prototype.onAdd.call(this);
        this.getElement().onerror = L.bind(this.fire, this, 'tileerror');

        this.mapPanePos = this._map._getMapPanePos();
        this.pixelOrigin = this._map.getPixelOrigin();
        this.zoom = this._map.getZoom();
    },

    onRemove: function (map) {
        L.ImageOverlay.prototype.onRemove.call(this, map);
        if (this._dObj && this._dObj._map) {
            this._dObj._map.removeLayer(this._dObj);
        }
    },

    exportGeometry: function () {
        var pathPoints = MSQR(this._image, {path2D: false, maxShapes: 10}),
            _map = this._map;

        if (_map) {
            var mapPanePos = this.mapPanePos,
                pixelOrigin = this.pixelOrigin,
                zoom = this.zoom;

            var layerPointToLatLng = function (point) {
                var layerPoint = L.point(point).subtract(mapPanePos);
                var projectedPoint = layerPoint.add(pixelOrigin);
                return _map.options.crs.pointToLatLng(projectedPoint, zoom);
            };

            var rings = pathPoints.map(function (it) {
                var ring = it.map(function (p) {
                    return L.point(p.x, p.y);
                });
                ring = L.LineUtil.simplify(ring, 1);
                return ring.map(function (p) {
                    return layerPointToLatLng(p);
                });
            });

            if (rings.length) {
                return rings.length > 1 ? L.polygon(rings) : L.polygon(rings[0]);
            }
        }
    }
});


// WEBPACK FOOTER //
// ./src/components/CrossOriginOverlay.js